// In-memory cache so each manifest URL is fetched at most once per session.
export const parseM3u8MediaTracks = async (
  url: string,
): Promise<{ audio: string[]; subtitles: string[] }> => {
  try {
    const res = await fetch(url);
    const text = await res.text();

    const audio: string[] = [];
    const subtitles: string[] = [];

    const mediaRegex = /#EXT-X-MEDIA:([^\n]+)/g;
    let match: RegExpExecArray | null;
    while ((match = mediaRegex.exec(text)) !== null) {
      const line = match[1];
      const typeMatch = /TYPE=([^,]+)/.exec(line);
      const nameMatch = /NAME="([^"]+)"/.exec(line);
      if (!typeMatch || !nameMatch) continue;

      const mediaType = typeMatch[1].replace(/"/g, "").toUpperCase();
      const name = nameMatch[1];

      if (mediaType === "AUDIO") audio.push(name);
      if (mediaType === "SUBTITLES" || mediaType === "CLOSED-CAPTIONS")
        subtitles.push(name);
    }

    return {
      audio: Array.from(new Set(audio)),
      subtitles: Array.from(new Set(subtitles)),
    };
  } catch (error) {
    return {
      audio: [],
      subtitles: [],
    };
  }
};
